import React from "react";
import { useState } from 'react';
import { fetchWithAuth } from "../auth"

const AssignGW = ({ isOpen, onClose, idSensor }) => {

    async function assignGW() {
        await fetchWithAuth('/sensor_gw', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: idSensor, gw: serialGWState })
        })
            .then(data => {
                setSerialGWState('')
                onClose()
            })
    }

    const [serialGWState, setSerialGWState] = useState('')
    const handleSerialGWChange = (event) => { setSerialGWState(event.target.value) }

    if (!isOpen) return null;

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <div
                style={{
                    background: "white",
                    height: 300,
                    width: 480,
                    margin: "auto",
                    padding: "2%",
                    border: "2px solid #000",
                    borderRadius: "10px",
                    boxShadow: "2px solid black",
                }}
            >
                <input type="text" value={serialGWState} onChange={handleSerialGWChange} />
                <button type="button" onClick={assignGW}>
                    Assegna
                </button>
                <button type="button" onClick={onClose}>
                    Chiudi
                </button>
            </div>
        </div>
    );
};

export default AssignGW;
